import TooltipSection from 'modules/campaigns/modules/common-campaign-form/components/TooltipSection';
import { FormattedMessage } from 'modules/taboola-common-frontend-modules/i18n';
import styles from './campaignCreativeTypeTooltip.module.scss';

export const CampaignCreativeTypeTooltip = () => (
    <TooltipSection bodyClass={styles['text']}>
        <FormattedMessage
            id="campaign.creative.type.tooltip.message.text"
            defaultMessage="Select the format of your ad creative:{newline}
            <ul><li>Display: Traditional banner ads that appear on websites in standard sizes.</li>
            <li>Native: Ads designed to blend seamlessly with the content and style of the site where they appear.</li>
            </ul>{newline}
Once selected, this cannot be changed."
        />
    </TooltipSection>
);
